var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-row',{attrs:{"justify":"center","align-content":"center"}},[_c('v-col',{attrs:{"text-center":""}},[_vm._v(" Hello,MIST太郎 ")])],1),_c('v-row',{attrs:{"justify":"center","align-content":"center"}},[_c('img',{attrs:{"src":_vm.top_image}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }